import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_roen_10: FaireProductEntity = {
  token: "legacy_prod_roen-10",
  type: "product",
  name: "Hotel Flori",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/96d04afeceee947a812f6f859d945e5207cf39c5bebbf128062b8048f2812330.webp",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: true,
  brandAvatarUrl: "/images/ROEN/Brand%20Page/roen-avatar.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  brandToken: "catalog_brand_roen",
  description: "Premium candle from ROEN.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["candles", "home fragrance", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
